import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

@Injectable()
export class CameraService {
    getPicture(source: CameraSource = CameraSource.Camera) {
        return Camera.getPhoto({
            quality: 50,
            width: 1600,
            height: 1600,
            resultType: CameraResultType.Base64,
            source,
            correctOrientation: true,
        }).then(photo => photo.base64String);
    }
}
